// extracted by mini-css-extract-plugin
module.exports = {"description":"Info_description__WkzSZ","gameDescription":"Info_gameDescription__1R7Zi"};